export const Top4Filled = () => {
    return (
        <svg width="118" height="89" viewBox="0 0 118 89" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M53.4964 88.2124L56.6493 66.4145H20.5041L22.6436 52.4265L66.2204 0.787611H85.3627L77.931 51.0277H87.277L85.0249 66.4145H75.679L72.5261 88.2124H53.4964ZM42.1237 51.0277H58.9013L62.392 26.8985L42.1237 51.0277Z"
                fill="#1D252D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.8748 0H86.2489L78.8171 50.2401H88.1617L85.6791 67.2021H76.3343L73.1814 89H52.6131L55.766 67.2021H19.6133L21.9263 52.0792L65.8748 0ZM66.566 1.57522L23.3607 52.7738L21.3948 65.6269H57.5324L54.3796 87.4248H71.8707L75.0235 65.6269H84.3706L86.3921 51.8153H77.0447L84.4765 1.57522H66.566ZM63.531 24.3421L59.5566 51.8153H40.4538L63.531 24.3421ZM43.7934 50.2401H58.2459L61.2528 29.4549L43.7934 50.2401Z"
                fill="url(#paint0_linear_3611_4847)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_3611_4847"
                    x1="53.8985"
                    y1="-29.1416"
                    x2="53.8985"
                    y2="122.867"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#3A4755" />
                </linearGradient>
            </defs>
        </svg>
    );
};
